const platform = {
    title: 'Platform ayarları',
    subtitle: 'Kiracılar arası yöneticileri ve genel platform görünümünü yönetin.',
    branding_title: 'Platform markası',
    branding_description: 'Konsol, kimlik doğrulama, hesap merkezi, demolar ve yardım merkezine uygulanır.',
    product_name: 'Ürün adı',
    slogan: 'Slogan',
    light_logo: 'Açık tema logosu',
    dark_logo: 'Koyu tema logosu',
    upload_logo: 'Logo yükle',
    uploading: 'Yükleniyor…',
    logo_uploaded: 'Logo yüklendi',
    hide_open_source_notice: 'Açık kaynak bildirimini gizle',
    hide_open_source_notice_description: 'Görünür atıf bağlantılarını gizler; lisans ve kaynak dosyalarını korur.',
    save: 'Değişiklikleri kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Platform markası kaydedildi',
    administrators_title: 'Platform yöneticileri',
    administrators_description: 'Tüm kiracıları ve örnek düzeyi ayarları yönetebilirler.',
    administrator_identifier_placeholder: 'Kullanıcı kimliği, kullanıcı adı veya e-posta',
    add_administrator: 'Yönetici ekle',
    administrator_added: 'Platform yöneticisi eklendi',
    remove_administrator: 'Platform yöneticisini kaldır',
};
export default Object.freeze(platform);
